<template>
    <qmWxBtn>
        <div class="topic-body">
            <div class="topic-bg">
                <div class="topic-bg-2">
                </div>
            </div>
            <div class="topic-content">
                <img src="@/assets/images/wish_home_img_taolunqu.png" alt="">
            </div>
            <img class="topic-bg-3" src="@/assets/images/wish_img_bg_fire.png" alt="">
            <img class="topic-title-discussion" src="@/assets/images/title-discussion.png" alt="">
            <p class="topic-btn-1" ref="topicBtn1Ref" @click="handleTopicClick('1')"></p>
            <p class="topic-btn-2" ref="topicBtn2Ref" @click="handleTopicClick('2')"></p>
        </div>
    </qmWxBtn>
</template>

<script lang="ts" setup>
import qmWxBtn from '@common/components/qm-wx-btn.vue';
import { handleLogin } from '@common/assets/ts/utils';
import { useStoreCommon } from '@common/store/common';
import { useIntersectionObserver } from '@common/hooks/useIntersectionObserver';
import { ref, watch, onMounted } from 'vue';
import { jsbReportV3 } from '@q-front-npm/jsbridge';
import { useStore } from '../store';

const storeCommon = useStoreCommon();
const store = useStore();
const topicBtn1Ref = ref<HTMLElement>();
const topicBtn2Ref = ref<HTMLElement>();

onMounted(() => {
    const intersectionObserver1 = useIntersectionObserver({
        threshold: 1,
    });
    intersectionObserver1.targetRef.value = topicBtn1Ref.value as HTMLElement;
    watch(() => intersectionObserver1.isIntersecting.value, (newVal) => {
        if (newVal) {
            jsbReportV3('26wish_social_button_show', {content: 1,});
            intersectionObserver1.disconnect();
        }
    }, { immediate: true, once: true, });

    const intersectionObserver2 = useIntersectionObserver({
        threshold: 1,
    });
    intersectionObserver2.targetRef.value = topicBtn2Ref.value as HTMLElement;
    watch(() => intersectionObserver2.isIntersecting.value, (newVal) => {
        if (newVal) {
            jsbReportV3('26wish_social_button_show', {content: 2,});
            intersectionObserver2.disconnect();
        }
    }, { immediate: true, once: true, });
});

const handleTopicClick = (type: string) => {
    if (!handleLogin(storeCommon.userInfo.user_type.toString())) return;
    jsbReportV3('26wish_social_button_click', {content: type,});
    store.goToTopic(store.topicList[type == '1' ? 0 : 1]);
};
</script>

<style lang="scss" scoped>
.topic-body {
    position: relative;
    width: 672px;
    margin: 0 auto;
    border-radius: 24px;
    padding: 12px;
    margin-top: 162px;
}
.topic-bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: 24px;
    // background: linear-gradient(180deg, rgba(255, 252, 238, 1), rgba(240, 134, 73, 1));
    // padding: 1PX;
    box-sizing: border-box;
    opacity: 0.8;
    z-index: 1;
}
.topic-bg-2 {
    width: 100%;
    height: 100%;
    border-radius: 24px;
    background: rgba(240, 134, 73, 1);
    opacity: 1;
    border: 0.5px solid rgba(251, 219, 127, 0.6);
}
.topic-content {
    position: relative;
    z-index: 5;
    background: linear-gradient( 180deg, #FEF0C0 0%, #FFF3C7 100%);
    border-radius: 20px;
    width: 100%;
    padding-top: 40px;
    img {
        width: 100%;
    }
}
.topic-bg-3 {
    position: absolute;
    top: -122px;
    left: 0;
    width: 100%;
    z-index: 0;
}
.topic-title-discussion {
    position: absolute;
    transform: translateX(calc(336px - 50%));
    width: 256px;
    top: -76px;
    z-index: 8;
}
.topic-btn-1, .topic-btn-2 {
    position: absolute;
    width: 140px;
    height: 60px;
    bottom: 190px;
    right: 60px;
    z-index: 9;
}
.topic-btn-2 {
    bottom: 80px;
}
</style>
